<template>
<div class="mr15">
  <sui-page-contents>
    <sui-grid ref="grid" :columns="gridColumns0" :dataset="'dataset0'" :pageable="false" :filterable="true" :sortable="true">
    </sui-grid>    
  </sui-page-contents>
</div>
</template>
<script>

export default {
  name: 'SampleGridTree',
  data() {
    return {
			multiSelectOptions: [{
            key: 'm1',
            label: 'aulti1',
          },
          {
            key: 'm2',
            label: 'bulti2',
          },
          {
            key: 'm3',
            label: 'culti3',
          },
          {
            key: 'm4',
            label: 'dulti4',
          },
          {
            key: 'm11',
            label: 'aulti1',
          },
          {
            key: 'm12',
            label: 'bulti2',
          },
          {
            key: 'm13',
            label: 'culti3',
          },
          {
            key: 'm14',
            label: 'dulti4',
          },
          {
            key: 'm21',
            label: 'aulti1',
          },
          {
            key: 'm22',
            label: 'bulti2',
          },
          {
            key: 'm23',
            label: 'culti3',
          },
          {
            key: 'm24',
            label: 'dulti4',
          },
    	],
      gridColumns0: [
				{
          text: 'treeItem',
          datafield: 'treeItem',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellTreeItem(row, column, value, htmlElement, {
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
				},
        {
          text: 'textField',
          datafield: 'pageName',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
              trim: true,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },        
				{
          text: 'multiSelect',
          datafield: 'multiselect',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellMultiSelect(row, column, value, htmlElement, {
							 optionList: this.multiSelectOptions,
            }, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
      ],      
      localdata0: [
        {
          'treeItem': {checked: true, depth: 0, text: 'item01'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: true, depth: 1, text: 'item02'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: false, depth: 1, text: 'item03'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: true, depth: 2, text: 'item04'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: true, depth: 2, text: 'item05'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: false, depth: 0, text: 'item06'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: null, depth: 1, text: 'item07'},
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: true, depth: 2, text: 'item08'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: true, depth: 0, text: 'item09'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
        {
          'treeItem': {checked: true, depth: 0, text: 'item10'},          
          "pageName": "배치작업이력",          
          'multiselect': 'm1, m2',
        },
      ],
    };
  },
  mounted() {
  },
  datasets: [
    {
			id: 'dataset0',
			type: 'local',
			data: 'localdata0',
			treeinfo: {
				'data-field': 'treeItem',
				'id-field': 'id',
				'parentid-field': 'parentid',
			},
			treefield: 'treeItem',
			datafields: [
				{
						"name": "pageName",
						"type": "string",
						"map": "pageName"
				},
				{
						"name": "treeItem",
						"type": "object",
						"map": "treeItem"
				},
				{
						"name": "multiselect",
						"type": "object",
						"map": "multiselect"
				},
			]
   	},  
  ],
  methods: {
    
  }
};
</script>

<style scoped>
.comm_btn_scr {
  width: 100px;
  height: 30px;
  background-color: #22A;
  color: white;
}
.my-list {
  width: 150px;
  border: 1px solid blue;
}
</style>
